import { CostCenterPriceModel } from './../archive/cost-center-price.model';
import { StoreModel } from 'src/app/models/archive/store.model';
import { ArticleModel } from 'src/app/models/archive/article.model';
import { SuspensionModel } from './suspension.model';

export class SuspensionDetailModel {
  suspensionDetailId: number = 0;
  suspensionId: number = 0;
  suspension: SuspensionModel | null = null;
  articleId: number = 0;
  article: ArticleModel | null = null;
  storeId: number = 0;
  store: StoreModel | null = null;
  quantity: number = 0;
  days: number = 0;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
  costCenterPrice: CostCenterPriceModel | null = null;
}
